export const orderTypeForLocale = {
    own: '자사 주문',
    b2b: 'B2B 주문',
    shared: '공유 주문',
};
export default {
    OWN: 'own',
    B2B: 'b2b',
    SHARED: 'shared',
};
